import { SmartContractEnum, TSmartContract } from "@/types";
import { AppThunk } from "..";
import { contractApi } from "@/apis";
import { IInfoWagmiConfig, sliceActions } from "./smart-contract.slice";

export const loadContracts =
  (chainId: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const loadedContracts = getState().contract.infoWagmiConfig;
      const objs: { key: TSmartContract; var: string }[] = [
        {
          key: SmartContractEnum.IDENTITY,
          var: "identity",
        },
        {
          key: SmartContractEnum.AFFILIATE_MANAGER,
          var: "affiliateManager",
        },
        {
          key: SmartContractEnum.FREE_GAS_MANAGER,
          var: "freeGasManager",
        },
        {
          key: SmartContractEnum.FIAT,
          var: "fiat",
        },
        {
          key: SmartContractEnum.SINGLE_ASSET_BASE,
          var: "singleAssetBase",
        },
        {
          key: SmartContractEnum.PANCAKE_ROUTER,
          var: "pancakeRouter",
        },
        {
          key: SmartContractEnum.PANCAKE_FACTORY,
          var: "pancakeFactory",
        },
        {
          key: SmartContractEnum.COLLECTION_ASSET_BASE,
          var: "collectionAssetBase",
        },
        {
          key: SmartContractEnum.PROJECT_PROFILE,
          var: "projectProfile",
        },
        {
          key: SmartContractEnum.COLLECTION_ASSET_EXCHANGE,
          var: "collectionAssetExchange",
        },
        {
          key: SmartContractEnum.SINGLE_POOL_ROUTER,
          var: "singlePoolRouter",
        },
        {
          key: SmartContractEnum.SINGLE_POOL_FACTORY,
          var: "singlePoolFactory",
        },
        {
          key: SmartContractEnum.TOPUP_MANAGER,
          var: "topupManager",
        },
        {
          key: SmartContractEnum.HYPER_POOL_ROUTER,
          var: "hyperPoolRouter",
        },
        {
          key: SmartContractEnum.HYPER_ASSET_BASE,
          var: "hyperAssetBase",
        },
        {
          key: SmartContractEnum.VAULT_MANAGER,
          var: "vaultManager",
        },
        {
          key: SmartContractEnum.VERIFY_DOCUMENT_MANAGER,
          var: "verifyDocumentManager",
        },
      ];

      const contracts = {};
      const contractsNeedLoad = objs.filter((item) => {
        if (
          chainId == loadedContracts[item.var]?.chain_id &&
          !!loadedContracts[item.var]?.abi
        )
          return false;
        else return true;
      });

      const contractKeys = contractsNeedLoad.map((item) => {
        return item.key;
      });

      if (contractKeys.length > 0) {
        const resContracts = await contractApi.getContract(
          JSON.stringify(contractKeys),
          chainId
        );

        contractsNeedLoad?.forEach((item) => {
          contracts[item.var] = resContracts[item.key];
        });

        // + add information wagmi config
        dispatch(
          sliceActions.getInforWagmiConfigSuccess(contracts as IInfoWagmiConfig)
        );
      }
    } catch (e) {
      console.log("🚀 ~ e:", e);
    }
  };

export const self = sliceActions;
